/**
 * Forces focus on field input by schema property path
 * @param property - property path on schema eg. ".firstname" or ".sub_form.firstname"
 */
export const focusOnField = (property: string) => {
    if (!property || typeof property !== "string") return;
    let uniqueClassName = "root_" + property; //  property.replace(/^\./g, "root_");
    let fieldElement = document.getElementsByClassName(uniqueClassName)[0];

    if (!fieldElement) {
        fieldElement = document.querySelectorAll(".field.error")[0];
    }

    if (fieldElement) {
        const inputElement = fieldElement.querySelectorAll("INPUT, SELECT, TEXTAREA,  [tabindex]:not([tabindex=\"-1\"])")[0] as HTMLInputElement | undefined;

        if (inputElement) {
            inputElement.focus();
        }
    }
};
